/**
 * MultiplayerHUD — player list sidebar for multiplayer games.
 *
 * Target beacon and cooldown stats are rendered in the header bar
 * by MultiplayerGame.jsx directly (consistent with SoloGame pattern).
 */

import BombIcon from './BombIcon';

export default function MultiplayerHUD({
  players,
  bombs = {},
}) {
  return (
    <div className="mp-players">
      <div className="mp-players-header">Players</div>
      {players.map(p => {
        const playerBombs = bombs[p.id] || 0;
        return (
          <div
            key={p.id}
            className="mp-player"
          >
            <span className="mp-player-indicator">{'\u00B7'}</span>
            <span className="mp-player-name">{p.name}</span>
            {playerBombs > 0 && (
              <span className="mp-player-bombs"><BombIcon size={12} /> {playerBombs}</span>
            )}
          </div>
        );
      })}
    </div>
  );
}
